export default '/static/frontend/ReachDigital/12gobiking/dist/assets/maestro-dd91313e.svg'